import React, { useEffect, useState } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

//Nouislider
import Nouislider from "nouislider-react";
// import "../../../../node_modules/nouislider/distribute/nouislider.css";
import ReviewDiscount from './ReviewDiscount';
import ReviewRating from './ReviewRating';

const ReviewCategoryFilter = () => {
    const [mincost, setMincost] = useState(0);
    const [maxcost, setMaxcost] = useState(2000);

    //Review Filter
    const onUpdate = (value) => {
        setMincost(value[0]);
        setMaxcost(value[1]);
    }
    useEffect(() => {
        onUpdate([0, 2000]);
    }, []);
    return (
        <React.Fragment>
            <Accordion flush defaultActiveKey="0" className="filter-accordion">


                {/* ReviewDiscount */}
                <ReviewDiscount />

                {/* ReviewRating */}
                <ReviewRating />
            </Accordion>
        </React.Fragment>
    )
}

export default ReviewCategoryFilter
